import Chart from '@app/components/various/Chart';
import { Tag } from '@app/components/various/Icons';
import { Popover } from '@app/components/various/Popover';
import { itemsToChart } from '@app/ducks/helpers';
import { isDefined } from '@app/utils/is';
import { Items, Preset } from '@typings';

interface Props {
  title: string;
  items: Omit<Preset.Item, 'sizeId'>[];
  itemTable?: Items.Table.Any;
}

export const ProductQuantityPreview = ({ title, items, itemTable }: Props) => {
  const quantitySum = items.reduce((sum, { quantity }) => sum + quantity, 0);

  if (!isDefined(itemTable)) {
    return <div className="body-2">{quantitySum}</div>;
  }

  const table = itemsToChart(items, itemTable);

  return (
    <div className="w-fit">
      <Popover contentHeader={title} content={<Chart table={table} />} placement="top-end">
        <div className="flex items-center gap-1">
          <Tag className="size-4 text-neutral-40" />
          <span className="body-2">{quantitySum}</span>
        </div>
      </Popover>
    </div>
  );
};
